import styled from "styled-components";

export const NotificationStyles = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  margin: 8px 0;
  background: ${({ theme }) => theme.colors.warn[50]};
  border: 1px solid ${({ theme }) => theme.colors.warn[100]};
  border-radius: 10px;
  font-size: 13px;
  line-height: 18px;

  .bellCircle {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    background: ${({ theme }) => theme.colors.warn[500]};
    color: #fff;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .bellCircle svg {
    width: 12px;
    height: 12px;
  }

  .body {
    flex: 1;
    color: ${({ theme }) => theme.colors.warn[700]};
    font-weight: 500;
  }

  .time {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.warn[600]};
    flex-shrink: 0;
  }
`;
